import { gql, useQuery } from "@apollo/client";

export function useOrganisation() {
  return useQuery(
    gql`
      query getOrganisations {
        organisations {
          _id 
          name
        }
      }
    `
  );
}

export function useOrganisationDetail(id : String) {
  return useQuery(
    gql`
      query getOrganisationDetail($_id: MongoID!) {
        organisation (_id: $_id) {
          _id 
          name
          description
          nudge_delay
          nudge_interaction
          nudge_no_interaction_start
          allow_user_customisation
          eap_link
          image_id
          image_name
          image_width
          company_policy_nudge_schedules {
            _id
            day
            time
          }
        }
      }
    `,
    {
      variables: {
        _id: id
      }
    }
  );
}

export function useUserOrganisationDetail() {
  return useQuery(
    gql`
      query getCurrentUserOrganisation {
        me 
        {
          organisation {
            _id
            name
            nudge_delay
            nudge_interaction
            nudge_no_interaction_start
            allow_user_customisation
            image_id
          }
        }
      }
    `,
    {}
  );
}

export function useUserOrganisationLogo() {
  return useQuery(
    gql`
      query getCurrentUserOrganisationLogo {
        me 
        {
          organisation {
            name
            image_id
            eap_link
            image_width
          }
        }
      }
    `,
    {
      fetchPolicy : 'cache-and-network'
    }
  );
}

export function useUserOrganisationSchedules() {
  return useQuery(
    gql`
      query getUserOrganisationSchedules {
        me 
        {
          _id
          organisation {
            _id
            company_policy_nudge_schedules {
              _id
              day
              time
            }
          }
        }
      }
    `,
    {
      fetchPolicy : 'cache-and-network'
    }
  );
}


